import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../Loader';
import _ from 'lodash';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  currentItem: PropTypes.object.isRequired,
};

const defaultProps = {
  loading: true
};

const AnimalInfoPanel = (props) => {

  const { loading } = props;
  const { animal_information: animalInfoBody } = props.currentItem;

  let out = (
    <div className={`widget panel qa ${loading ? 'loading' : ''}`}>
      {
        loading ?
        <Loader dark fill /> :
        <div className="text-justify" dangerouslySetInnerHTML={{__html: animalInfoBody}} />
      }
    </div>
  );

  return out;

}

AnimalInfoPanel.propTypes = propTypes;
AnimalInfoPanel.defaultProps = defaultProps;

export default AnimalInfoPanel;
